import React from "react";

const TermsAndConditionsComp = () => {
  const date = new Date();
  const formattedDate = `${date.getDate()}/${
    date.getMonth() + 1
  }/${date.getFullYear()}`;
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">BAF Token Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Last updated: {formattedDate}
      </p>

      <section className="mb-6">
        <p>
          This Privacy Policy describes how BAF Token (the "Site", "we", "us",
          or "our") collects, uses, and discloses your personal information when
          you visit, use our services, or make a purchase from{" "}
          <a
            href="https://app.baf.com"
            className="text-blue-600 hover:underline"
          >
            https://app.baf.com
          </a>{" "}
          (the "Site") or otherwise communicate with us (collectively, the
          "Services").
        </p>
        <p className="mt-2">
          By using and accessing any of the Services, you agree to the
          collection, use, and disclosure of your information as described in
          this Privacy Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Changes to This Privacy Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time. We will post the
          revised Privacy Policy on the Site and update the "Last updated" date.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          How We Collect and Use Your Personal Information
        </h2>
        <p>
          We collect personal information about you from various sources,
          including directly from you, through cookies, and from third parties.
          The information varies depending on how you interact with our
          Services.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Information We Collect Directly from You
        </h2>
        <ul className="list-disc pl-6">
          <li>Basic contact details</li>
          <li>Order information</li>
          <li>Account information</li>
          <li>Shopping information</li>
          <li>Customer support communications</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Information We Collect through Cookies
        </h2>
        <p>
          We use cookies and similar technologies to automatically collect usage
          data such as browser info, IP address, and interactions with the Site.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Information We Obtain from Third Parties
        </h2>
        <p>
          We may obtain information from vendors, service providers (like
          Shopify), and advertising partners. This data is treated in accordance
          with this Privacy Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          How We Use Your Personal Information
        </h2>
        <ul className="list-disc pl-6">
          <li>Providing products and services</li>
          <li>Marketing and advertising</li>
          <li>Security and fraud prevention</li>
          <li>Customer communication and support</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Cookies</h2>
        <p>
          We use cookies for analytics, personalization, and improving the user
          experience. You can control cookies through your browser settings.
        </p>
        <p className="mt-2">
          See more at:{" "}
          <a
            href="https://www.shopify.com/legal/cookies"
            className="text-blue-600 hover:underline"
          >
            Shopify Cookie Policy
          </a>
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          How We Disclose Personal Information
        </h2>
        <p>
          We may disclose your information to vendors, partners, affiliates, or
          legal authorities in connection with providing Services or as required
          by law.
        </p>
        <p className="mt-2">
          Categories disclosed include identifiers, commercial data, and
          internet activity.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">User Generated Content</h2>
        <p>
          Any content you post publicly may be accessible by others. We do not
          control the use or security of public information.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Third Party Websites and Links
        </h2>
        <p>
          Links to third-party websites are provided for your convenience. We
          are not responsible for their privacy practices or content.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Children's Data</h2>
        <p>
          Our Services are not intended for children. If you believe a child has
          provided us personal data, please contact us to request deletion.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsComp;
